import Api from './Api'

export default {
    getEstados() {
        return Api().get('https://servicodados.ibge.gov.br/api/v1/localidades/estados');
    },
    getCidades(uf){
        return Api().get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
    }
}